<template lang="pug">
  .b-contact-tile
    ._info
      span._date {{ item.email }}
    ._item-actions
      Btn(sm @click="$emit('remove')" grey transparent) Отменить заявку
</template>

<script>

export default {
  name: 'ContactRequestTile',
  props: {
    item: Object,
  },
};
</script>

<style scoped lang="scss">
.contact-tile {
  display: grid;
  gap: 15px;

  background: #fff;
  padding: 15px 20px;
  border-radius: 6px;
  box-shadow: 0 6px 12px rgb(0 0 0 / 8%);

  &__item-actions {
    justify-self: end;
    display: flex;
    gap: 15px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
  }

  &__date {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #1E3147;
    transition: color 0.3s;
    cursor: pointer;

    &:hover {
      color: var(--color-hover);
    }
  }

  &__ellipsis {
    opacity: 0;
  }

  &:hover &__ellipsis {
    opacity: 1;
  }
}
</style>
